export default __webpack_public_path__ + "pgnv-assets/c2521e326e0c28485c0370049c278768.png";